import { render, staticRenderFns } from "./DistributionLoginPage.vue?vue&type=template&id=7a2a016e&scoped=true"
import script from "./DistributionLoginPage.vue?vue&type=script&lang=js"
export * from "./DistributionLoginPage.vue?vue&type=script&lang=js"
import style0 from "./DistributionLoginPage.vue?vue&type=style&index=0&id=7a2a016e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2a016e",
  null
  
)

export default component.exports